import React, { useState, useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Notification from './index'
import { AppUseSelector } from '../../redux/hooks'

const COOKIE_NAME = 'notification_dismissed'
const COOKIE_DURATION = 24 * 60 * 60 * 1000 // 24 hours

const isNotificationDismissed = (id: string) => {
  const cookies = document.cookie.split(';')
  const notificationCookie = cookies.find((cookie) => cookie.trim().startsWith(`${COOKIE_NAME + id}=`))
  if (notificationCookie) {
    const timestamp = parseInt(notificationCookie.split('=')[1])
    const now = Date.now()
    return now - timestamp < COOKIE_DURATION
  }
  return false
}

const FreeTrialNotification: React.FC = () => {
  const { t } = useTranslation('offers')
  const { reminder, credentials } = AppUseSelector(({ user }) => user)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!isNotificationDismissed(credentials?.memberId) && reminder) {
      setVisible(true)
    }
  }, [])

  const handleClose = () => {
    const now = Date.now()
    const expires = new Date(now + COOKIE_DURATION)
    document.cookie = `${COOKIE_NAME + credentials?.memberId}=${now}; expires=${expires.toUTCString()}; path=/`
    setVisible(false)
  }

  if (!visible || !reminder) return null

  return (
    <Notification type='warning' onClose={handleClose}>
      <>
        <strong>{t('freeTrialNotice.title', { days: Number(reminder) })}</strong>
        <div>
          <Trans
            t={t}
            i18nKey='freeTrialNotice.body'
            components={{ upgrade: <a className='notification-link' href='/settings#plan' /> }}
          />
        </div>
      </>
    </Notification>
  )
}

export default FreeTrialNotification
